import {
  useQuery,
  useMutation,
  UseMutationOptions,
} from "@tanstack/react-query";
import { generateColorFromEmail } from "../../../functions";
import axios from "axios";
import { deleteContact, postSingleContact } from "./contacts";
import { useQueryClient } from "@tanstack/react-query";

export const getAgents = async (): Promise<Agent[]> => {
  const endpoint = "/cdk-collections/v2/agents";
  const res = await axios.get(endpoint);
  const resWithColors = res.data.map((v: Agent) => {
    return { ...v, color: generateColorFromEmail(v.email) };
  });
  return resWithColors;
};

export const getAgentsByList = async (list_id: string | number): Promise<Agent[]> => {
  const endpoint = `https://api.momentumsolar.io/cdk-collections/v2/lists/${list_id}/agents`;
  const res = await axios.get(endpoint);
  const resWithColors = res.data.data.map((v: Agent) => {
    return { ...v, color: generateColorFromEmail(v.email) };
  });
  return resWithColors;
};

export const useAgents = () => {
  return useQuery({
    queryKey: ["all-agents"],
    queryFn: getAgents,
  });
};

export const useAgentsByList = ({ list_id }: { list_id: string | number }) => {
  return useQuery({
    queryKey: ["agents-by-list", list_id],
    queryFn: () => getAgentsByList(list_id),
  });
};

const postAgentToContact = async (body: AgentPostBody): Promise<void> => {
  try {
    const { contact_id } = body;
    await deleteContact({ contact_id });

    const { household_id, agent_email, list_name, created_by } = body;
    await postSingleContact({
      household_id,
      agent_email,
      list_name,
      created_by,
    });

    return;
  } catch (err) {
    console.error("postAgentToContact error", err);
    throw err;
  }
};

export const useAgentMutation = (
  options?: UseMutationOptions<void, Error, AgentPostBody>,
) => {
  const queryClient = useQueryClient();
  return useMutation<void, Error, AgentPostBody>({
    mutationFn: postAgentToContact,
    ...options,
    onSuccess: (...args) => {
      // Internal behavior
      queryClient.invalidateQueries({
        queryKey: ["contacts-by-list"],
        exact: false,
      });
      queryClient.invalidateQueries({
        queryKey: ["all-contacts"],
        exact: false,
      });
      queryClient.invalidateQueries({
        queryKey: ["agents-by-list"],
        exact: false,
      });

      // Call the user-passed onSuccess if it exists
      options?.onSuccess?.(...args);
    },
  });
};
